import TermsandConditions from "../Components/Terms/TermsandConditions.tsx";

const TermsConditions = () => {
  return (
    <>
      <TermsandConditions />
    </>
  );
};

export default TermsConditions;
